import React from 'react';
import Typography from '@material-ui/core/Typography';
import Helmet from 'react-helmet';
import { Query, useMutation } from 'react-apollo';
import { GET_TEMPLATE, UPDATE_TEMPLATE } from 'graphql/timeline-templates';
import Spin from 'components/common/Spin';
import Builder from './components/Builder';
import { useSelector } from 'react-redux';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import { Box } from '@material-ui/core';

const Edit = ({ match, canEdit, history }) => {
  const user = useSelector((s) => s.user.user);
  const [updateTemplate] = useMutation(UPDATE_TEMPLATE);

  const onSave = (values) => {
    return updateTemplate({
      variables: {
        id: match.params.id,
        data: {
          name: values.name,
          data: values.milestones,
        },
      },
    });
  };

  return (
    <div>
      <Helmet title="Edit Milestone Template" />
      <Box display="flex" alignItems='center'>
        <IconButton
          color={'primary'}
          onClick={() => history.goBack()}
          style={{ marginRight: 8, padding: 2 }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography>{canEdit ? `Edit Template` : `View Template`}</Typography>
      </Box>
      <Query query={GET_TEMPLATE} variables={{ id: match.params.id }}>
        {({ data, loading }) => {
          if (loading) return <Spin spinning linear />;

          const template = {
            name: data.row.name,
            milestones: data.row.data,
          };
          return <Builder canEdit={canEdit} history={history} data={template} onSave={onSave} />;
        }}
      </Query>
    </div>
  );
};

export default Edit;
